// extracted by mini-css-extract-plugin
export var pillWrapper = "_r4-0";
export var showOverflow = "_r4-1";